import { useState, useCallback } from "react";
import { Typography, Box, IconButton, Tooltip } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import HowFeesWork from "./HowFeesWork";

const Label = ({ text, tooltip = "More info", showIcon = false, textColor=null }) => {
    const [showHowFeesWorks, setShowHowFeesWorks] = useState(false);

    const handleOpen = useCallback(() => setShowHowFeesWorks(true), []);
    const handleClose = useCallback(() => setShowHowFeesWorks(false), []);

    return (
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography sx={{ fontWeight: "bold" }} color={textColor || "#000"}>
                {text}
            </Typography>

            {showIcon && (
                <>
                    <Tooltip title={tooltip}>
                        <IconButton size="small" onClick={handleOpen}>
                            <HelpOutlineIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                    <HowFeesWork show={showHowFeesWorks} closeModal={handleClose} />
                </>
            )}
        </Box>
    );
};

export default Label;